export const ownersState = (state) => state.owners;

export const getLoadingOwners = (state) => ownersState(state).loading;

export const getOwner = (state) => ownersState(state).owner;

export const getOwnersLoaded = (state) => ownersState(state).owners;

export const getResponseOwner = (state) => ownersState(state).response;
